import { createFileRoute } from '@tanstack/react-router'
import { UserRole } from '@depanneo/types'
import { requiredRoles } from '@/shared/utils/require-roles'

const VALID_SORT_FIELDS = new Set([
  'id',
  'reference',
  'priority',
  'title',
  'organizationName',
  'site',
  'equipmentName',
  'jobType',
  'technicianName',
  'status',
  'scheduledDate',
])

export type DashboardSearch = {
  page?: number
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  type?: string
  priority?: string
  status?: string
  trades?: string
  siteId?: string
  equipmentId?: string
  organizationId?: string
  service?: string
  technicianId?: string
  postalCode?: string
  quoteRequested?: string
  unassignedOnly?: string
  lateOnly?: string
  dateFrom?: string
  dateTo?: string
  search?: string
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/(dashboard)/dashboard'
)({
  validateSearch: (search: Record<string, unknown>): DashboardSearch => {
    const str = (v: unknown) => (typeof v === 'string' ? v : undefined)
    return {
      page:
        typeof search.page === 'number'
          ? search.page
          : typeof search.page === 'string'
            ? Number(search.page) || undefined
            : undefined,
      sortBy:
        typeof search.sortBy === 'string' &&
        VALID_SORT_FIELDS.has(search.sortBy)
          ? search.sortBy
          : undefined,
      sortOrder:
        search.sortOrder === 'asc' || search.sortOrder === 'desc'
          ? search.sortOrder
          : undefined,
      type: str(search.type),
      priority: str(search.priority),
      status: str(search.status),
      trades: str(search.trades),
      siteId: str(search.siteId),
      equipmentId: str(search.equipmentId),
      organizationId: str(search.organizationId),
      service: str(search.service),
      technicianId: str(search.technicianId),
      postalCode: str(search.postalCode),
      quoteRequested: str(search.quoteRequested),
      unassignedOnly: str(search.unassignedOnly),
      lateOnly: str(search.lateOnly),
      dateFrom: str(search.dateFrom),
      dateTo: str(search.dateTo),
      search: str(search.search),
    }
  },
  beforeLoad() {
    requiredRoles([UserRole.VIEWER, UserRole.ADMIN, UserRole.FACILITY_MANAGER])
  },
})
